// extracted by mini-css-extract-plugin
module.exports = {"statsPin":"StatsPin-module--stats-pin--1VLMg"};